import { render, staticRenderFns } from "./LanguagesSelect.vue?vue&type=template&id=3b34def1&scoped=true"
import script from "./LanguagesSelect.vue?vue&type=script&lang=js"
export * from "./LanguagesSelect.vue?vue&type=script&lang=js"
import style0 from "./LanguagesSelect.vue?vue&type=style&index=0&id=3b34def1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b34def1",
  null
  
)

export default component.exports